export interface PriceDetailsPopinDto {
    readonly linkLabel: string;
    readonly basePrice: number | null;
    readonly totalDiscountsAndCashbacksAmount: number | null;
    readonly hasDifferentNonPermanentDurations: boolean;
    readonly discounts: ReadonlyArray<PriceDetailsDiscountDto>;
    readonly totalBeforeRefundLabel: string;
    readonly totalBeforeRefund: number;
    readonly cashbacks: ReadonlyArray<PriceDetailsCashbackDto>;
    readonly finalPriceLabel: string;
    readonly finalPrice: number;
    readonly finalPriceDuration: number | null;
    readonly finalPricePermanent: number | null;
}

export interface MultiplePriceDetailsPopinDto {
    readonly linkLabel: string;
    readonly offersPriceDetails: ReadonlyArray<OfferPriceDetailsDto>;
    readonly finalPrice: number;
    readonly finalPermanentPrice: number;
    readonly finalPriceDuration: number;
    readonly finalPriceLabel: string;
}

export interface OfferPriceDetailsDto {
    readonly offerType: string;
    readonly offerName: string;

    readonly initialPrice: number;
    readonly discountedPrice: number;
    readonly discountedPermanentPrice: number;
    readonly finalDiscountedPrice: number;
    readonly finalPermanentPrice: number;

    readonly finalPriceDuration: number;
    readonly finalPriceDurationLabel?: string;

    readonly discounts: ReadonlyArray<PriceDetailsDiscountDto>;
    readonly cashbacks: ReadonlyArray<PriceDetailsCashbackDto>;

    readonly discountedPriceLabel: string;
    readonly finalPriceLabel: string;
}

export enum PriceDetailsDiscountType {
    INTERNET_CLIENT = 'INTERNET_CLIENT',
    MOBILE_CLIENT = 'MOBILE_CLIENT',
    SAFER_PHONE = "SAFER_PHONE",
    OTHER = 'OTHER',
}

export interface PriceDetailsDiscountDto {
    readonly label: string;
    readonly amount: number;
    readonly duration: number;
    readonly durationLabel: string | null;
    readonly invoiceMention: string | null;
    readonly type: PriceDetailsDiscountType;
}

export enum PriceDetailsCashbackType {
    CHEAT_CODE = "CHEAT_CODE",
    SAFER_PHONE = "SAFER_PHONE",
    OTHER = "OTHER"
}

export interface PriceDetailsCashbackDto {
    readonly label: string;
    readonly amount: number;
    readonly duration: number;
    readonly durationLabel: string;
    readonly invoiceMention: string;
    readonly ctaLabel: string;
    readonly url: string;
    readonly cashbackType: PriceDetailsCashbackType;
}
